import { render, staticRenderFns } from "./LkControl.vue?vue&type=template&id=30b53004&scoped=true&"
import script from "./LkControl.vue?vue&type=script&lang=js&"
export * from "./LkControl.vue?vue&type=script&lang=js&"
import style0 from "./LkControl.vue?vue&type=style&index=0&id=30b53004&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b53004",
  null
  
)

export default component.exports